<template>
  <div v-if="getUserByUserId.role !== 'employee'">
    <base-button
      size="sm"
      type="primary"
      class="rounded-sm px-4"
      @click.stop="handleClick"
      v-if="
        channel.type === 'private' && planValidator(getUserByUserId, channel)
      "
      >Join</base-button
    >

    <base-button
      size="sm"
      type="primary"
      class="rounded-sm px-4"
      @click.stop="handleClick"
      v-else-if="channel.type === 'public'"
      >Join</base-button
    >
    <base-button
      size="sm"
      :type="`${
        channel.hasOwnProperty('planId') && channel.planId.length > 0
          ? 'success'
          : 'danger'
      }`"
      class="rounded-sm px-1"
      :disabled="
        !channel.hasOwnProperty('planId') && channel.planId.length == 0
      "
      @click.stop="handleUpgardePlan"
      v-else
      >{{
        channel.hasOwnProperty("planId") && channel.planId.length > 0
          ? "Upgrade Plan"
          : "Plan Not Selected"
      }}</base-button
    >
  </div>
  <div
    v-else-if="
      getUserByUserId.currentMembership.name === 'Corporate Premium' &&
      getUserByUserId.role === 'employee'
    "
  >
    <base-button
      size="sm"
      type="primary"
      class="rounded-sm px-4"
      @click.stop="handleEmpJoin"
      >Join</base-button
    >
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    channel: {
      type: Object,
      default: () => {},
    },

    data() {
      return {
        Price: "",
      };
    },
  },
  computed: {
    ...mapState("auth", {
      user: "user",
      getUserByUserId: "getUserByUserId",
    }),
  },
  methods: {
    handleClick() {
      // if (this.channel.type === "private") {
      //   this.handlePrivateJoin();
      // } else if (this.channel.type === "public") {
      this.handlePublicJoin();
      // }
    },
    planValidator(userPlans, channelPlanId) {
      // console.log(userPlans, channelPlanId);
      if (channelPlanId.hasOwnProperty("planId")) {
        if (channelPlanId.planId.length > 0) {
          let plan = userPlans.membership.filter(
            (e) => e == channelPlanId.planId[0]._id
          );
          if (plan.length > 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    joinAlert() {
      return this.$swal({
        text: `Would you like to become a member of ${this.channel.name}?`,
        icon: "question",
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
      });
    },

    async handlePrivateJoin() {
      const result = await this.joinAlert();
      if (result.isConfirmed) {
        this.$swal.fire({
          text: `Your payment done succesfully`,
          icon: "success",
          confirmButtonText: "Ok",
          showCancelButton: false,
          cancelButtonColor: "#60d394",
        });
        this.$store.dispatch("channel/joinChannel", {
          channelID: this.channel._id,
        });
      }
    },
    handleUpgardePlan() {
      if (
        this.channel.hasOwnProperty("planId") &&
        this.channel.planId.length > 0
      ) {
        localStorage.setItem("upgrade", true);
        this.$router.push({
          name: "product-services",
          query: { scroll: true },
        });
      } else {
        this.$swal.fire({
          text: `Please select a valid Plan`,
          icon: "error",
          confirmButtonText: "Ok",
          showCancelButton: false,
          cancelButtonColor: "#60d394",
        });
      }
    },
    async handlePublicJoin() {
      const result = await this.joinAlert();
      if (result.isConfirmed) {
        const payload = {
          channelID: this.channel._id,
          // UserID: [this.user._id],
          addMember: "true",
        };
        const payload2 = {
          channelID: this.channel._id,
          UserID: [this.user._id],
        };
        let loader = this.$loading();
        try {
          await this.$store.dispatch("channel/addMember", payload);
          this.$store.commit("channel/ADD_MEMBER", payload2);
          loader.close();
        } catch (error) {
          if (error) {
            loader.close();
          }
        }
      }
    },

    async handleEmpJoin() {
      const result = await this.joinAlert();
      if (result.isConfirmed) {
        const payload = {
          channelID: this.channel._id,
          UserID: [this.user._id],
        };
        let loader = this.$loading();
        try {
          await this.$store.dispatch("channel/empChannelJoin", payload);
          this.$store.commit("channel/ADD_MEMBER", payload);
          loader.close();
        } catch (error) {
          console.log(error);
          if (error) {
            loader.close();
          }
        }
      }
    },
  },
  async mounted() {
    // await this.$store.dispatch("auth/getUserByUserId", {
    //   userId: this.user._id,
    // });
    // this.planValidator(this.getUserByUserId, this.channel);
  },
};
</script>
